export default __webpack_public_path__ + "static/seth-nicole-alyssa-jovern-4dc52581623161777e4109168b737d42.png";